import { useQuery } from '@tanstack/react-query'
import { UseBaseQueryOptions } from '@/core/api/type'
import { MessagingQueryKey } from '../../keys'
import MessagingService from '../services'
import { MessageConditionSingleResponse } from '../../types'

function useQueryGetMessageConditions(
	props?: UseBaseQueryOptions<MessageConditionSingleResponse>,
) {
	return useQuery({
		queryKey: [MessagingQueryKey.GetMessageConditionsSingle],
		queryFn: () => MessagingService.getMessageConditionsSingle(),
		...props,
	})
}

export default useQueryGetMessageConditions
